import script from "./BlogCatalog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogCatalog.vue?vue&type=script&lang=ts&setup=true"

import "./BlogCatalog.vue?vue&type=style&index=0&id=185468a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-185468a0"]])

export default __exports__